// @ts-strict-ignore
import type { Action } from 'flow/store/engine/types';
import { ActionType } from '../../../store/engine/constants';
import { isActionOfType } from '../actions';
import { isPreviewOutcomeAction } from '../outcomes';
import { isPreviewWorkflowRoutingAction } from '../workflowRouting';

/**
 * A "preview" action is one the user is actively building but hasn't committed yet: a standalone
 * preview action (e.g. a preview tag), or a not-yet-finished preview outcome / workflow-routing
 * action.
 */
export function isPreviewAction(action: Action): boolean {
  return isActionOfType(action, ActionType.PREVIEW)
    || isPreviewOutcomeAction(action)
    || isPreviewWorkflowRoutingAction(action);
}
